export default __webpack_public_path__ + "static/media/done.5a58c8da.svg";